import { render, staticRenderFns } from "./JRB1off.vue?vue&type=template&id=10e604ce"
import script from "./JRB1off.vue?vue&type=script&lang=js"
export * from "./JRB1off.vue?vue&type=script&lang=js"
import style0 from "./JRB1off.vue?vue&type=style&index=0&id=10e604ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports